<template>
    <ul class="select-payment" v-if="paymentMethodsSafe.length">
        <Swiper
            class="swiper payment-slider"
            :modules="[Navigation]"
            :spaceBetween="swiperOptionTop.spaceBetween"
            :slides-per-view="swiperOptionTop.slidesPerView"
            :breakpoints="swiperOptionTop.breakpoints"
            ref="swiperTop">
            <SwiperSlide
                class="swiper-slide"
                v-for="(paymentMethod, index) in paymentMethodsSafe"
                :key="paymentMethod.id">
                <div
                    class="slide-inner"
                    :class="{ disabled: (paymentMethod.id === 1 && shippingSelect === 4) }">
                    <input
                        type="radio"
                        class="filter-payment__checkbox checkout__checkbox"
                        :id="`payment-${paymentMethod.id}`"
                        name="payment_id"
                        :disabled="(paymentMethod.id === 1 && shippingSelect === 4)"
                        :value="paymentMethod.id"
                        v-model="paymentSelectLocal"/>
                    <label
                        :for="`payment-${paymentMethod.id}`"
                        class="payment-label checkout-input-label"
                        :title="paymentMethod.name">
                        <div class="payment-name checkout-field-name">
                            {{ paymentMethod.name }}
                        </div>
                        <div class="pay-icon-list" v-if="paymentMethod.id === 2">
                            <img src="/assets/images/visa.png" />
                            <img src="/assets/images/master.png" />
                            <img src="/assets/images/mir.png" />
                            <img src="/assets/images/maestro.png" />
                        </div>
                    </label>
                </div>
            </SwiperSlide>
        </Swiper>
    </ul>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

import { useStore } from 'vuex'
const store = useStore()

const swiperTop = ref(null)

const swiperOptionTop = {
    spaceBetween: 20,
    slidesPerView: 3,
    breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 10 },
        500: { slidesPerView: 2, spaceBetween: 15 }
    }
}

// --- Payment methods из стора как массив, даже если api заглючит
const paymentMethodsSafe = computed(() => {
    const arr = store.getters.paymentMethods
    return Array.isArray(arr) ? arr : []
})

// --- shippingSelect из стора
const shippingSelect = computed(() => store.getters.shippingSelect)

// --- Локальное выбранное значение, реактивно связано с store
const paymentSelectLocal = ref(
    paymentMethodsSafe.value.length ? paymentMethodsSafe.value[0].id : 1
)

// --- Синхронизация стора и локального значения
watch(paymentMethodsSafe, (methods) => {
    const current = store.getters.paymentSelect

    if (
        methods.length > 0 &&
        !methods.find(x => x.id === current)
    ) {
        const defaultId = methods[0].id
        paymentSelectLocal.value = defaultId
        store.commit('setPaymentSelect', defaultId)
    }
}, { immediate: true })


watch(paymentSelectLocal, (value) => {
    store.commit('setPaymentSelect', value)
})



</script>

<style scoped>
.swiper-slide-active .product-slide__img {
    border-radius: 4px;
}
.disabled {
    opacity: 0.6;
    pointer-events: none;
}
</style>
